import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'vehiclebrands',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `vehiclebrands`,
    method: 'get',
    params: queriesParams
  })
}

export function add (vehicleBrand) {
  return request({
    url: 'vehiclebrand',
    method: 'post',
    data: vehicleBrand
  })
}

export function show (id) {
  return request({
    url: `vehiclebrand/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `vehiclebrand/${id}`,
    method: 'patch',
    data
  })
}